import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Typography, CardHeader, CardMedia, CardContent, Button, Container, Tab, Tabs, Grid, Box, Avatar, Card, Paper } from '@material-ui/core';
import styles from "./Common.module.scss";
import { data } from './local';
import { eventEmitter, getToken, getNominatorId, getUserInfo } from './common';
import { useHistory } from 'react-router-dom';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { UserImage } from "./SearchBox";
import { getDraftNominations } from './services';
import { NominationCards } from './NominationCards';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: any;
    value: any;
}

const NomDashboard: FunctionComponent<any> = () => {
    let history: any = useHistory()
    const [token, setToken] = useState<any>(null);
    useEffect(() => {
        getToken().then((token: any) => {
            setToken(token);
        });
    }, [])


    const globalState: any = useSelector((state: any) => {
        const { lang, dashboard } = state;
        return { lang, dashboard }
    });
    const languageData: any = data;
    const { nomDashboard } = languageData[globalState.lang];
    const { sent, recieved } = globalState.dashboard;
    // const { stateSent, dispatchSent } = useContext<any>(SentContext);
    // const { stateReceived, dispatchReceived } = useContext<any>(ReceivedContext);

    const handleBack = () => {
        history.push("/");
    }

    let location = useLocation();
    return (
        <React.Fragment>
            <Container maxWidth={"xl"} style={{minHeight:'100vh'}}>
                
            <div className={styles.BackNavEditor} ><ArrowBackIosIcon /><span onClick={handleBack} className={styles.messageBox}>BACK</span></div>

                <Typography variant="h5" style={{ margin: '5px', padding: '10px', fontFamily: 'Barlow', fontSize: "30px" }}>{nomDashboard.title}</Typography>
                <Grid container direction='row'>
                    <Paper elevation={3} style={{ width: '250px', height: '100px', margin: '5px', padding: '10px' }} >
                        <Typography variant="h6" style={{ margin: '5px', fontFamily: 'Barlow', fontSize: "18px" }}>{nomDashboard.sent}</Typography>
                        <Typography variant="h2" style={{ margin: '5px', paddingTop: '10px', fontFamily: 'Barlow', fontSize: "40px" }}>{sent}</Typography>
                    </Paper>
                    <Paper elevation={3} style={{ width: '250px', height: '100px', margin: '5px', padding: '10px' }} >
                        <Typography variant="h6" style={{ margin: '5px', fontFamily: 'Barlow', fontSize: "18px" }}>{nomDashboard.received}</Typography>
                        <Typography variant="h2" style={{ margin: '5px', paddingTop: '10px', fontFamily: 'Barlow', fontSize: "40px" }}>{recieved}</Typography>
                    </Paper>
                </Grid>


                <NominationCards showViewMore={false} token={token} showAll={true} />
                <Grid style={{ paddingBottom: "200px" }}></Grid>



            </Container>
        </React.Fragment>
    );
}
export default NomDashboard;